import { render, staticRenderFns } from "./PhotoNews.vue?vue&type=template&id=42ff915b&scoped=true"
import script from "./PhotoNews.vue?vue&type=script&lang=js"
export * from "./PhotoNews.vue?vue&type=script&lang=js"
import style0 from "./PhotoNews.vue?vue&type=style&index=0&id=42ff915b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff915b",
  null
  
)

export default component.exports